import api from '@/api/index.js'

const account = {
  state: {
    loading: false,
    updating: false,
    data: null,
    id: null, // Loaded account ID.
    error: null,
    availableAccountTraits: ['no_limitations', 'personal_top_ups_forbidden'],
  },

  mutations: {
    SET_ACCOUNT_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_UPDATING: (state, loading) => {
      state.updating = loading
    },
    SET_ACCOUNT: (state, account) => {
      state.data = account
      if (account) {
        state.id = account.id
      } else {
        state.id = null;
      }
      state.loading = false
      state.updating = false
    },
    SET_ACCOUNT_ERROR: (state, error) => {
      state.error = error
      state.loading = false
      state.updating = false
    },
  },

  actions: {
    SearchAccount({commit}, query) {
      commit('SET_ACCOUNT', null)
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_LOADING', true)

      let urlQuery = ""
      if (query.searchBy == 'byEmail') {
        urlQuery = `reference_key=${query.reference_key}&email=${encodeURIComponent(query.email)}`
      } else if (query.searchBy == 'byIdentifier') {
        urlQuery = `identifier=${query.identifier}`
      } else if (query.searchBy == 'bySerialNumber') {
        urlQuery = `serial_number=${query.serial_number}`
        if (query.serial_number_emv) {
          urlQuery += '&emv=true'
        }
      } else if (query.searchBy == 'byPublicId') {
        urlQuery = `public_id=${query.public_id}`
      } else if (query.searchBy == 'byAccountId') {
        urlQuery = `account_id=${query.account_id}`
      }

      // return api.get(`account/search?identifier=${filters.identifier}&public_id=${filters.public_id}&serial_number=${filters.serial_number}&reference_key=${filters.reference_key}&email=${encodeURIComponent(filters.email)}`)
      return api.get(`account/search?${urlQuery}`)
        .then((response) => {
          commit('SET_ACCOUNT', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
        })
    },
    LoadAccount({commit}, id) {
      commit('SET_ACCOUNT', null)
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_LOADING', true)
      return api.get(`accounts/${id}`)
        .then((response) => {
          commit('SET_ACCOUNT', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    UpdateAccountDiscount({commit}, payload) {
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_UPDATING', true)
      return api.put(`accounts/${payload.id}/discount`, payload.data)
        .then((response) => commit('SET_ACCOUNT', response.body))
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
          commit('SET_ACCOUNT_UPDATING', false)
        })
    },
    UpdateAccountStatus({commit}, payload) {
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_UPDATING', true)
      return api.put(`accounts/${payload.id}/status`, payload.data)
        .then((response) => commit('SET_ACCOUNT', response.body))
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
          commit('SET_ACCOUNT_UPDATING', false)
        })
    },
    UpdateAccountTrait({commit}, payload) {
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_UPDATING', true)
      return api.put(`accounts/${payload.id}/trait`, payload.data)
        .then((response) => commit('SET_ACCOUNT', response.body))
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
          commit('SET_ACCOUNT_UPDATING', false)
        })
    },
    AccountCardReplace({commit}, payload) {
      commit('SET_ACCOUNT_ERROR', null)
      commit('SET_ACCOUNT_UPDATING', true)
      return api.put(`accounts/${payload.id}/card-replace`, payload.data)
        .then((response) => commit('SET_ACCOUNT_UPDATING', false))
        .catch((error) => {
          commit('SET_ACCOUNT_ERROR', error)
          commit('SET_ACCOUNT_UPDATING', false)
        })
    }
  },
}

export default account
